import React, { useState, useEffect } from 'react'
import { Formik, Field } from 'formik'
import * as Yup from 'yup'
import './styles.scss'
import { LngLat } from 'mapbox-gl'
import { submitPlace, submitChanges, adminPublishMarker } from 'lib/model'
import { Marker } from 'types/markers'
import { getAdminDisplayName } from 'lib/adminHelper'
import fr from 'locales/fr.yaml'
import { useHistory } from 'react-router-dom'
const localisationStrings = { fr }

export const AddMarkerForm = ({
  locale,
  visible,
  editMarker,
  adminView,
  markerData,
  articleId,
  newMarkerPosition,
  handleClose
}: {
  locale: 'fr'
  visible: boolean
  editMarker: boolean
  adminView: boolean
  markerData: Marker | undefined
  articleId: number
  newMarkerPosition: LngLat | undefined
  handleClose: () => void
}) => {
  const [isVisible, setIsVisible] = useState(visible)
  const [currentStep, setCurrentStep] = useState(0)
  const [formSent, setFormSent] = useState(false)
  const [filterCheckboxInvalid, setfilterCheckboxInvalid] = useState(false)
  const [initialValuesDictionary, setInitialValuesDictionary] = useState({
    title: '',
    description: '',
    pseudo: '',
    filters: [
      {
        name: 'wheelchair',
        type: 'access',
        value: false
      },
      {
        name: 'bike',
        type: 'access',
        value: false
      },
      {
        name: 'car',
        type: 'access',
        value: false
      },
      {
        name: 'publicTransportation',
        type: 'access',
        value: false
      },
      {
        name: 'weekend',
        type: 'familyFriendly',
        value: false
      },
      {
        name: 'kidMenu',
        type: 'familyFriendly',
        value: false
      },
      {
        name: 'outsidePlayground',
        type: 'familyFriendly',
        value: false
      },
      {
        name: 'insidePlayground',
        type: 'familyFriendly',
        value: false
      },
      {
        name: 'babyChangingTable',
        type: 'familyFriendly',
        value: false
      }
    ]
  })
  const history = useHistory()

  useEffect(() => {
    setIsVisible(visible)
  }, [visible])

  useEffect(() => {
    if (formSent === true && isVisible === false) {
      // Reset Form
      setFormSent(false)
      setCurrentStep(0)
    }
  })

  useEffect(() => {
    if (editMarker === true) {
      console.log('Editing current marker values:', markerData)
      console.log('adminView is', adminView)
    }

    setInitialValuesDictionary({
      title: editMarker ? markerData.title : '',
      description: editMarker ? markerData.description : '',
      pseudo: editMarker ? markerData.nickname : 'Anonyme',
      filters: editMarker
        ? markerData.filters
        : [...initialValuesDictionary.filters]
    })
  }, [editMarker])

  const validationSchema = Yup.object({
    title: Yup.string()
      .max(30, 'Doit faire maximum 30 caractères')
      .required('Requis'),
    description: Yup.string()
      .max(300, 'Doit faire maximum 300 caractères')
      .required('Requis'),
    pseudo: Yup.string().max(15, 'Doit faire maximum 15 caractères')
  }).test('filterTest', obj => {
    const filters = [
      ...initialValuesDictionary.filters.filter(
        f => f.type === 'familyFriendly'
      )
    ]

    filters.forEach(f => {
      f.value = obj[f.name]
    })

    if (filters.some(filter => filter.value === true)) {
      setfilterCheckboxInvalid(false)
      return true // everything is fine
    }

    setfilterCheckboxInvalid(true)

    // TODO: reformuler
    return new Yup.ValidationError(
      'Merci de choisir au moins une activité',
      null,
      'filterErrorMessage'
    )
  })

  const nextStep = () => {
    // TODO: check if yup validation passes
    // console.log( Yup.reach(validationSchema, 'title').validate("test") )
    setCurrentStep(1)
  }
  const previousStep = () => {
    setCurrentStep(0)
  }

  return formSent ? (
    <div className={`ui modal form-container ${isVisible && 'active'}`}>
      <div className='content'>
        <p>
          Merci pour votre contribution!{' '}
          {editMarker
            ? 'Les modifications sont'
            : 'Ce restaurant est maintenant'}{' '}
          en attente de validation.
        </p>
        <div className='field'>
          <button
            className='ui button'
            role='button'
            onClick={() => {
              history.replace('/')
            }}
          >
            Revenir à la liste des restaurants
          </button>
          <button className='ui button' role='button' onClick={handleClose}>
            Fermer
          </button>
        </div>
      </div>
    </div>
  ) : (
    <div className={`ui modal form-container ${isVisible && 'active'}`}>
      <div className='content'>
        <div className='two column row'>
          <div className='right floated column'>
            <button
              className='ui icon right floated circular grey button'
              onClick={handleClose}
            >
              <i className='close icon' />
            </button>
          </div>

          <div className='left floated column'>
            <h4 className='ui header'>
              {(editMarker ? 'Modifier' : 'Ajouter') + ' un lieu'}
            </h4>
          </div>
        </div>

        <div className='row'>
          <Formik
            initialValues={initialValuesDictionary}
            validationSchema={validationSchema}
            validateOnBlur
            enableReinitialize
            onSubmit={(values, actions) => {
              // We send the suggested values to firebase
              const filters = [...initialValuesDictionary.filters]

              filters.forEach(f => {
                f.value = values[f.name] | false
              })
              console.log('Filters>', filters)

              const newMarker: Marker = {
                title: values.title,
                description: values.description,
                latitude: newMarkerPosition.lat,
                longitude: newMarkerPosition.lng,
                nickname: values.pseudo,
                needsReview: true,
                filters: filters
              }
              if (editMarker === false) {
                submitPlace(newMarker, articleId)
              } else {
                // Merge edits and previous marker data
                const markerUpdatedData = markerData
                for (const [key, value] of Object.entries(newMarker)) {
                  markerUpdatedData[key] = value
                }
                if (adminView) {
                  adminPublishMarker(markerUpdatedData, getAdminDisplayName())
                } else {
                  submitChanges(markerUpdatedData, articleId)
                }
              }

              // We thank the user
              setFormSent(true)
            }}
          >
            {props => (
              <form className='ui form' onSubmit={props.handleSubmit}>
                <div
                  className={
                    'step step1 ' + (currentStep === 0 ? 'visible' : 'hidden')
                  }
                >
                  <div className='field'>
                    <label htmlFor='title'>Nom du lieu</label>
                    <Field
                      id='title'
                      placeholder='Par exemple: plage de Nyon'
                      type='text'
                      {...props.getFieldProps('title')}
                      // onChange={() => props.handleChange}
                    />
                    {props.errors.title && (
                      <div className='feedback'>{props.errors.title}</div>
                    )}
                  </div>

                  <div className='field'>
                    <label htmlFor='description'>Description</label>
                    <Field
                      as='textarea'
                      id='description'
                      placeholder='Une courte description en une ou deux phrases'
                      {...props.getFieldProps('description')}
                      // onChange={() => props.handleSubmit}
                    />
                    {props.errors.description && (
                      <div className='ui pointing label feedback'>
                        {props.errors.description}
                      </div>
                    )}
                  </div>

                  <div className='field'>
                    <label htmlFor='pseudo'>Pseudo (facultatif)</label>
                    <Field
                      id='pseudo'
                      type='text'
                      {...props.getFieldProps('pseudo')}
                    />
                    {props.errors.pseudo && (
                      <div className='ui pointing label feedback'>
                        {props.errors.pseudo}
                      </div>
                    )}
                  </div>

                  <div className='field'>
                    <button
                      className='ui primary button'
                      role='button'
                      type='button'
                      onClick={nextStep}
                    >
                      Continuer
                    </button>
                    <button
                      className='ui button'
                      role='button'
                      type='button'
                      onClick={handleClose}
                    >
                      Annuler
                    </button>
                  </div>
                </div>

                {/* <div className='ui section divider' /> */}

                <div
                  className={
                    'step step2 ' + (currentStep === 1 ? 'visible' : 'hidden')
                  }
                >
                  <p className='ui section horizontal divider'>
                    {localisationStrings[locale].filtersTitle}
                  </p>
                  {initialValuesDictionary.filters
                    .filter(f => f.type === 'familyFriendly')
                    .map(filter => (
                      <div className='field' key={`filter-${filter.name}`}>
                        <div className='ui toggle checkbox'>
                          <Field
                            type='checkbox'
                            name={filter.name}
                            id={filter.name}
                            checked={filter.value}
                          />
                          <label htmlFor={filter.name}>
                            {localisationStrings[locale][filter.name]}
                          </label>
                        </div>
                      </div>
                    ))}

                  <div className='field'>
                    <div
                      className={
                        'feedback filterErrorMessage ' +
                        (filterCheckboxInvalid ? 'visible' : 'hidden')
                      }
                    >
                      Merci de choisir au moins une activité.
                    </div>
                  </div>

                  <div className='field field-inline'>
                    <p className='ui section horizontal divider'>
                      Accès facile…
                    </p>

                    {initialValuesDictionary.filters
                      .filter(f => f.type === 'access')
                      .map(filter => (
                        <div className='field' key={`filter-${filter.name}`}>
                          <div className='ui toggle checkbox'>
                            <Field
                              type='checkbox'
                              name={filter.name}
                              id={filter.name}
                              // checked={filter.value}
                            />
                            <label htmlFor={filter.name}>
                              {localisationStrings[locale][filter.name]}
                            </label>
                          </div>
                        </div>
                      ))}
                  </div>

                  <div className='field'>
                    {editMarker && (
                      <button className='ui primary button' type='submit'>
                        {adminView
                          ? 'Publier le lieu'
                          : 'Suggérer les modifications'}
                      </button>
                    )}
                    {!editMarker && (
                      <button className='ui primary button' type='submit'>
                        Proposer le lieu
                      </button>
                    )}
                    <button
                      className='ui button'
                      role='button'
                      type='button'
                      onClick={previousStep}
                    >
                      Revenir
                    </button>
                  </div>
                </div>
              </form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  )
}
